const downloadLocalFile = (fileName: string, content: string) => {
  const link = document.createElement('a');
  const blob = new Blob([content], { type: 'text' });

  link.setAttribute('download', fileName);
  link.setAttribute('href', URL.createObjectURL(blob));
  link.click();
};

export { downloadLocalFile };
